import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import BarLoaderComponent from 'webapp/components/bar-loader';

export default class BillingTrialBoxComponent extends Component {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('billing') declare billingService: Service.Billing;
	@service('account') declare accountService: Service.Account;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	@tracked isRequestTrialInProgress = false;

	get canBookACall(): boolean {
		return !this.currentUserService.isClientUserInPaidClientSpace;
	}

	@action
	requestTrial(): void {
		if (!this.isRequestTrialInProgress) {
			this.isRequestTrialInProgress = true;
			void this.billingService.requestTrial(null, null, 'billing_page').finally(() => {
				this.isRequestTrialInProgress = false;
			});
		}
	}

	@action
	startChat(): void {
		this.analyticsService.event(TrackingEvent.CHAT_INITIATED, { origin: 'billing_page_cta' });
		this.currentUserService.chatWithSupport();
	}

	@action
	bookACallLink(): void {
		this.analyticsService.event(TrackingEvent.CALL_INITIATED, { origin: 'billing_page_cta' });
		window.open(this.accountService.bookACallLink, '_blank');
	}
	<template>
		<div class="trial-box">
			<h3>Unlock the full power of Databox </h3>
			<p>
				By starting a trial, you can connect more data sources, create more dashboards,
				increase sync frequency, access more historical data and custom date ranges, build
				calculated and built metrics, visualize data from spreadsheets and databases, enable
				fiscal calendars or single sign-on, and more.
			</p>
			<div class="actions-1">
				<a role="button" class="button size-big" {{on "click" this.requestTrial}}>
					{{#if this.isRequestTrialInProgress}}
						<BarLoaderComponent @theme="white" />
					{{else}}
						Start a 14-day free trial
					{{/if}}
				</a>
				<small>Immediate access. No obligation. No credit card required.</small>
			</div>
			{{#if this.canBookACall}}
				<div class="actions-2">
					<strong>Have questions?</strong>
					<div class="button-ct">
						<a role="button" class="button size-big" {{on "click" this.startChat}}>
							Start a chat
						</a>
						<span>or</span>
						<a role="button" class="button size-big" {{on "click" this.bookACallLink}}>
							Book a call
						</a>
					</div>
				</div>
			{{/if}}
		</div>
	</template>
}
